import type React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ContentHeader from './components/Header/ContentHeader';
import { useConfig } from './hooks/useConfig';

type LayoutProps = {
  children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  const { backgroundImage } = useConfig();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();
  const title = pathname === '/card' ? 'common-phrases.akova-card' : 'common-phrases.akova-pay';

  vtlog('theme:', theme);

  return (
    <>
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: { xs: 'calc(100vh - 271px)', md: 'calc(100vh - 271px - 90px)' },
          width: '100%',
          backgroundImage: `url('${backgroundImage}')`,
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: { xs: '900%', sm: '500%', md: '350%', lg: '210%', xl: '145%' }
        }}
      >
        <Container
          maxWidth='sm'
          sx={{
            minWidth: '300px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            flexGrow: 1,
            paddingY: 8
          }}
        >
          <Paper
            sx={{
              borderRadius: 4,
              paddingY: 8,
              paddingX: 4
            }}
          >
            <Stack justifyContent='center' alignItems='center' gap={4}>
              <ContentHeader />
              <Box component='main'>{children}</Box>
            </Stack>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default Layout;
